import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getAboutUs, createAboutUs, updateAboutUs } from '../services/api';

export const AboutUsContext = createContext();

export const AboutUsProvider = ({ children }) => {
  const [aboutUs, setAboutUs] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const fetchAboutUs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAboutUs();
      setAboutUs(response.data);
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'اطلاعات درباره ما هنوز درج نشده است'
          : err.response?.data?.message || 'خطا در دریافت اطلاعات';
      setError(errorMessage);
      setAboutUs(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const addAboutUs = useCallback(async (aboutUsDto) => {
    setLoading(true);
    setError(null);
    setUploadProgress(0);
    try {
      const response = await createAboutUs(aboutUsDto, {
        onUploadProgress: (e) => {
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploadProgress(percent);
        },
      });
      setAboutUs(response.data);
      toast.success('اطلاعات درباره ما با موفقیت ثبت شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 400 && err.response.data.includes('امکان درج بیش از یک مورد')
          ? 'امکان درج بیش از یک مورد وجود ندارد'
          : err.response?.data?.message || 'خطا در ثبت اطلاعات';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  }, []);

  const editAboutUs = useCallback(async (id, aboutUsDto) => {
    setLoading(true);
    setError(null);
    setUploadProgress(0);
    try {
      const response = await updateAboutUs(id, aboutUsDto, {
        onUploadProgress: (e) => {
          const percent = Math.round((e.loaded * 100) / e.total);
          setUploadProgress(percent);
        },
      });
      setAboutUs(response.data);
      toast.success('اطلاعات درباره ما با موفقیت به‌روزرسانی شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'رکورد مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در به‌روزرسانی اطلاعات';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
      setUploadProgress(0);
    }
  }, []);

  return (
    <AboutUsContext.Provider
      value={{
        aboutUs,
        loading,
        error,
        uploadProgress,
        fetchAboutUs,
        addAboutUs,
        editAboutUs,
      }}
    >
      {children}
    </AboutUsContext.Provider>
  );
};